import React, { useEffect } from 'react'

export default function ChatWidget() {
	useEffect(() => {
		const scriptSrc = 'https://fw-cdn.com/16243142/7139117.js'

		const existing = document.querySelector(`script[src="${scriptSrc}"]`)
		if (existing) return

		const script = document.createElement('script')
		script.src = scriptSrc
		script.setAttribute('chat', 'true')
		script.async = true
		document.body.appendChild(script)
	}, [])

	return null
}
